import React from 'react';
import { DocumentTitle } from '@atlassian/jira-global-document-title/src/DocumentTitle.tsx';
import { useIntl } from '@atlassian/jira-intl';
import { fg } from '@atlassian/jira-feature-gating';
import messages from './messages.tsx';

export const GlobalPagesDocumentTitle = (): React.JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<DocumentTitle
			title={
				fg('blu-7514_update_jira_home_your_work_to_for_you')
					? formatMessage(messages.pageTitleForYou)
					: formatMessage(messages.pageTitleYourWork)
			}
		/>
	);
};
